<template>
	<div class="input-with-control ffl-number-inputs">
		<input type="text" maxlength="1" v-model="part1" ref="part1" @keyup="checkPart1"><span>-</span>
		<input type="text" maxlength="2" v-model="part2" ref="part2" @keyup="checkPart2"><span>-</span>
		<input type="text" value="XXX" disabled><span>-</span>
		<input type="text" value="XX" disabled><span>-</span>
		<input type="text" value="XX" disabled><span>-</span>
		<input type="text" maxlength="5" v-model="part3" ref="part3" @keyup="checkPart3">
		<div :class="['button', part1 && part2 && part3 && !searching ? 'action' : 'disabled', 'input-go']" @click="getList()"><i class="fas fa-search"></i></div>
		<div :class="['search-message-under', { show: noResults }]">No matching FFL numbers</div>
	</div>
</template>
<script>
export default {
	name: 'ffl-number-search',
	data() {
		return {
			part1: '',
			part2: '',
			part3: '',
			searching: false,
			noResults: false
		}
	},
	created() {
	},
	methods: {
		checkPart1(e) {
			if (isNaN(e.key)) { 
				this.part1 = '' 
			} else {
				this.$refs.part2.select()
			}
		},
		checkPart2(e) {
			if (isNaN(e.key)) {	
				this.part2 = this.part2.substring(0, this.part2.length - 1)
			} else {
				if (this.part2.length == 2)
					this.$refs.part3.select()
			}
		},
		checkPart3(e) {
			// keyCode 91 is paste, 8 is delete
			if (e.keyCode == 91 || e.keyCode == 8) { return }
			if (e.keyCode == 13 && this.part3.length == 5) {
				this.getList()
			}
			if (e.keyCode != 13 && isNaN(e.key)) {
				this.part3 = this.part3.substring(0, this.part3.length - 1)
			}
		},
		getList() {
			if (this.searching) { return }
			let searchTerm = this.part1 + this.part2 + this.part3
			if (searchTerm.length < 8) { return }
			this.searching = true
			this.apiCall({ destination: 'get_list_ffl_search', data: { search_term: searchTerm } }).then(obj => {
				this.searching = false
				if (obj.list.length == 0) {
					this.noResults = true
                    setTimeout(() => {  this.noResults = false }, 2000)
				} else {
					this.$emit('searchResult', obj.list);
					this.part1 = ''
					this.part2 = ''
					this.part3 = ''
				}
			}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.ffl-number-inputs {
	grid-template-columns: 2em 1em 2.75em 1em 3.5em 1em 2.75em 1em 2.75em 1em 1fr 3em;
	span { padding: 0.66em 0.33em; }
}
</style>
